import { render, staticRenderFns } from "./teacherFullName.vue?vue&type=template&id=ac6f3ecc&"
import script from "./teacherFullName.vue?vue&type=script&lang=js&"
export * from "./teacherFullName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports